// import axios from '../../http/axios';
import service from '../../http/axios';

export const getFirstClassOrgan = service({
  url: '/yinghe-api/organDeviceReference/firstClassOrgan',
});

export const getSecondClassOrgan = service({
  url: '/yinghe-api/organDeviceReference/secondClassOrgan',
});

export const getCheckItem = service({
  url: '/yinghe-api/organDeviceReference/checkItem',
});
